import React from "react"
import PropTypes from "prop-types"

const StarSm = ({
  style = {},
  width = "14px",
  className = "star",
  viewBox = "0 0 14 13"
}) => (
  <svg
    width={width}
    style={style}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
  >
    <polygon
      fillRule="evenodd"
      points="7.03030303 10.5454545 2.89799459 12.7179377 3.68719528 8.11654459 0.344087522 4.85781992 4.96414881 4.18648572 7.03030303 0 9.09645725 4.18648572 13.7165185 4.85781992 10.3734108 8.11654459 11.1626115 12.7179377"></polygon>
  </svg>
)

StarSm.propTypes = {
  style: PropTypes.object,
  width: PropTypes.string,
  className: PropTypes.string,
  viewBox: PropTypes.string
}

export default StarSm
